import React from 'react';
import HotelAllotmentItem from './HotelAllotmentItem';
import EventLabel from '../../../components/EventLabel/EventLabel';

export default function SearchResults(props) {
  const { results, show, currency, onAdd, fullbooked, displayEventSettings, maxBookCount, bookedCount } = props;
  if (!results) return null;

  return (
    <div>
      <div className="card-title">
        <div className="flex items-center gap-x-2">
          <i className="ri-search-line font" />
          <h3 className="semi-bold">
            <EventLabel name="SearchResult" groupName="CMS.Hotel" />
          </h3>
        </div>
      </div>
      <div className="card p-0 my-2">
        <div className="search-results">
          {results?.length > 0 ? (
            results.map(
              (
                {
                  price,
                  name,
                  type,
                  dateRangeString,
                  asRoomSize,
                  totalBeds,
                  nights,
                  imageUrl,
                  description,
                  size,
                  supplementPrice,
                  allotmentPricingIds,
                  supplementVatPercent,
                  vatPercent,
                },
                i
              ) => (
                <HotelAllotmentItem
                  key={i}
                  price={price}
                  show={show}
                  name={name}
                  type={type}
                  supplementVatPercent={supplementVatPercent}
                  supplementPrice={supplementPrice}
                  maxBookCount={maxBookCount}
                  bookedCount={bookedCount}
                  description={description}
                  vatPercent={vatPercent}
                  displayEventSettings={displayEventSettings}
                  totalBeds={totalBeds}
                  fullbooked={fullbooked.some(f => allotmentPricingIds.includes(f))}
                  dateRangeString={dateRangeString}
                  nights={nights}
                  currency={currency}
                  imageUrl={imageUrl}
                  size={asRoomSize}
                  onAdd={(quantity) => onAdd(allotmentPricingIds, quantity)}
                />
              )
            )
          ) : (
            <EventLabel name="NoResults" groupName="CMS.Hotel" />
          )}
        </div>
      </div>
    </div>
  );
}
